// extracted by mini-css-extract-plugin
export default {"policeTitre":"TitreH1_policeTitre__QmOR1"};